<div class="header" *ngIf="headerInfo">

    <div class="container">

        <div class="flmid row flspacebetween">
            <div class="col-auto mOrder1 pl-0">
                <ng-container *ngIf="headerInfo; else load_else">
                    <a  href="{{logoUrlLink}}" target="_blank" rel="noopener" class="logo-brand">
                        <img *ngIf="headerInfo.theme" class="headerImage" alt="Logo">
                    </a>
                </ng-container>
                <ng-template #load_else>
                    <img class="brand mainlogo" src="assets/images/logo.png" alt="Logo">
                </ng-template>
            </div>

            <div class="col-auto  mblock mOrder3 mr-auto">
                <h4 class="dealer-name" *ngIf="headerInfo">
                    <span class="truncate">{{headerInfo.dealerName}}</span>
                </h4>
            </div>
            <div *ngIf="!isProd" class="d-flex align-items-center text-danger" translate>
              lblTestingEnvironment
            </div>

            <div class="mOrder2 d-flex ml-auto">

                <a href="tel:{{headerInfo.dealerPhoneNo}}" class="btn btn-outline-primary d-flex align-items-center" (click)="CallDealerLogEntry()" translate>
                    <em class="fa fa-phone align-middle mr-2"></em> lblCallDealer</a>


                <div class="logoright lang-dropdown col-auto  pr-0">
                    <div style="width: 150px;" *ngIf="isLanguageFlag">
                        <ng-select [items]="languageModel" bindLabel="value" bindValue="key" (change)="ChangeLanguage($event.key)" [(ngModel)]="currentLang" [clearable]="false" [searchable]="false" ngDefaultControl>
                            <ng-template ng-label-tmp let-item="item">
                                <img height="15" alt="{{item.value}}" [src]="getFlagImage(item.flagName)" />
                                <strong class="lang">{{item.value}}</strong>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                <img height="15" alt="{{item.value}}" [src]="getFlagImage(item.flagName)" />
                                <strong class="lang">{{item.value}}</strong>
                            </ng-template>

                        </ng-select>
                    </div>
                </div>
                <div class="notification-box">
                    <button type="button" class="align-self-center ml-2" (click)="onNotificationClick()" aria-label="Center Align">
                    <em class="fa fa-bell font22 align-middle"></em>
                    <span
                        class="position-absolute translate-middle badge rounded-pill count"
                    >
                        {{ notificationCount }}
                    </span>
                    </button>
                    <div class="searchbox card fix lt" *ngIf="notificationPopupOpen">
                        <div class="padding-main bg-blue">
                            <div class="row mx-1 justify-content-between">
                                <div class="row align-items-center">
                                    <em class="fa fa-bell-o font16 mr-1"></em>
                                    <label>{{ notificationCount }}&nbsp;</label>
                                    <label translate>{{'lblUnreadNotification'|translate}}</label>
                                </div>
                                <div>
                                    <button (click)="markAllRead()" class="mark-read" translate>
                                        lblMarkallasread
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="overflow-auto" style="max-height:230px" >
                            <div *ngFor="let notification of notificationList; let i = index">
                                <div class="p-2 btm-border click" (click)="viewNotification(notification)">
                                    <div class="row mx-1 justify-content-between">
                                        <div>
                                            <p class="msg-header">{{ notification.subject }}</p>
                                        </div>
                                        <div>
                                            <p class="msg-date">{{ notification.timeAgo }}</p>
                                        </div>
                                    </div>
                                    <div class="mx-1">
                                        <p class="msg-subject" [innerHTML]="notification.content"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mx-1 justify-content-between align-items-center py-2">
                            <button (click)="loadcomponent()" class="read-btn" translate>
                            lblReadallNotifications
                            </button>
                            <button (click)="onNotificationClose()" aria-label="Center Align" class="btn btn-outline-tertiary mr-2" translate>
                            lblClose
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="header-bottom trackerBg" *ngIf="headerInfo">
    <div class="container" *ngIf="showorderstatus">

        <div class="row">
            <div class="col-sm-12 content d-flex justify-content-center align-items-center flex-column">
                <p class="font18 mt-3 mb-2">
                    <span class="font18 mt-3 mb-2" translate>
                        lblHi
                    </span>
                    <span class="font18 mt-3 mb-2">
                        {{headerInfo.customerName}}. 
                    </span>

                    <span class="font18 mt-3 mb-2">
                        <span translate>lblStatusOfYourOrder</span>: <span class="font16 font-weight-bold text-danger">{{headerInfo.orderNumber}}</span>
                    </span>

                </p>
                <div class="d-flex align-items-center">
                    <div class="licence-pl small text-center" [ngClass]="licensePlateClass">
                        <input type="text" aria-label="licencePlate" value="{{headerInfo.numberPlate}}" readonly />
                    </div>
                    <ng-container *ngIf="headerInfo?.vehileBrand">
                        <img af-brand-logo class="noBrandLogo" tabindex="0" data-placement="bottom" data-trigger="focus" [data-code]="headerInfo.vehileBrand?.toUpperCase()" data-type="BRAND" [alt]="headerInfo.vehileBrand"/>
                    </ng-container>
                </div> 

            </div>
        </div>
    </div>
</div>
